import React from 'react'
import { Link } from 'react-router-dom'

function JoinUs() {
  return (
    <div className='join-us' style={{backgroundColor:"#F1F1F1"}}>
      <div className='container p-5 join-us-main'>
      <div className=' fs-2 m-auto mt-5 fw-bold missionandvisiontextcolor d-flex justify-content-center text-center join-us-main-text-mobile-view'>Join Us in Building a Healthier Future</div>
    <div className='d-flex justify-content-center px-5 fs-4 mt-4 join-us-subcontent-mobile-view'>
      <div className='w-75 m-auto d-flex text-center join-us-content-mobile-view'>
      Make the shift from reactive care to predictive, 
      preventive healthcare with Vizzhy.  Together, we can create a future where health is not
      just about managing illness but about unlocking your full potential.
      </div>

    </div>

    <Link to="/contact" className="forgot-link">
    <div className='d-flex mt-4 justify-content-center pb-4'>
      <div className='d-flex primary-btn fw-bold  py-3 px-5 join-us-contact-us contact-us'>
        <div>Join Us</div>
        <span class="material-symbols-outlined ms-1">
          arrow_right_alt
        </span>
      </div>
    </div></Link>
    

      </div>
      
  </div>
  )
}

export default JoinUs